import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { formatAvailableDate } from '../util/DateFormatterUtil';
import { MessageListingDetails } from '../api/messages-client';
import { capitalizeFirstLetters } from '../util/AddressUtil';

interface MessageListingPreviewProps {
  listing: MessageListingDetails;
  senderName?: string;
}

const MessageListingPreview: React.FC<MessageListingPreviewProps> = ({ listing, senderName }) => {
  const today = new Date().toISOString().split('T')[0];
  const availabilityText = new Date(listing.availableFrom || '') <= new Date(today) 
    ? 'Available now' 
    : `Available ${formatAvailableDate(listing.availableFrom || '')}`;

  return (
    <div className="mb-2">
      {senderName && (
        <div className="mb-1.5">
          <p className="text-sm text-gray-500">
            {senderName} sent this regarding:
          </p>
        </div>
      )}
      
      <Link 
        to={`/listing/${listing.id}`}
        className="block w-full max-w-sm rounded-xl overflow-hidden border border-gray-200 bg-white hover:shadow-md transition-all duration-200"
      >
        <div className="relative">
          <img
            src={listing.image ? (
              /^(https?:\/\/|data:)/i.test(listing.image.trim())
                ? listing.image
                : `https://${listing.image}`
            ) : ""}
            alt="Property"
            className="w-full h-32 object-cover"
          />
          <div className="absolute bottom-2 left-2">
            <span 
              className={`text-sm px-2.5 py-1 rounded-full 
                ${availabilityText === 'Available now'
                  ? 'bg-[#24ccf2]/90 text-white'
                  : 'bg-white/90 text-gray-700'
                }
              `}
            >
              {availabilityText}
            </span>
          </div>
        </div>

        <div className="p-2.5 space-y-1">
          <div className="flex items-center justify-between text-sm">
            <div className="font-medium">${listing.rent} per week</div>
          </div>

          <div className="flex items-center gap-1.5 text-gray-600">
            <MapPin className="w-4 h-4" />
            <p className="text-sm truncate">
              {capitalizeFirstLetters(listing.locality_name)} {listing.postcode}
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MessageListingPreview;